import React from 'react';

interface Props {
  title: string;
  subtitle?: string;
}

/**
 * Public page header — migrated to EDS v1.0 tokens (WP2.1B).
 * Presentation-only: same `title`/`subtitle` API; forest brand wash + Sora display.
 */
const PageHeader: React.FC<Props> = ({ title, subtitle }) => {
  return (
    <section className="bg-gradient-to-br from-eds-forest to-eds-forest-2 text-white py-16">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <h1 className="font-eds-display text-4xl font-bold tracking-[-0.02em]">{title}</h1>
        {subtitle && <p className="font-eds-body text-white/70 mt-3 max-w-2xl">{subtitle}</p>}
      </div>
    </section>
  );
};

export default PageHeader;
